export default "__VITE_ASSET__DTqaFbSn__"